import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LoanController::store
* @see app/Http/Controllers/LoanController.php:19
* @route '//app.finesthub.de/properties/{estateObject}/loans'
*/
export const store = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/properties/{estateObject}/loans',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\LoanController::store
* @see app/Http/Controllers/LoanController.php:19
* @route '//app.finesthub.de/properties/{estateObject}/loans'
*/
store.url = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { estateObject: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { estateObject: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
    }

    return store.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanController::store
* @see app/Http/Controllers/LoanController.php:19
* @route '//app.finesthub.de/properties/{estateObject}/loans'
*/
store.post = (args: { estateObject: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\LoanController::update
* @see app/Http/Controllers/LoanController.php:34
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
export const update = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/properties/{estateObject}/loans/{loan}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\LoanController::update
* @see app/Http/Controllers/LoanController.php:34
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
update.url = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            loan: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        loan: typeof args.loan === 'object'
        ? args.loan.id
        : args.loan,
    }

    return update.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{loan}', parsedArgs.loan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanController::update
* @see app/Http/Controllers/LoanController.php:34
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
update.put = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\LoanController::update
* @see app/Http/Controllers/LoanController.php:34
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
update.patch = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\LoanController::destroy
* @see app/Http/Controllers/LoanController.php:45
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
export const destroy = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/properties/{estateObject}/loans/{loan}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\LoanController::destroy
* @see app/Http/Controllers/LoanController.php:45
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
destroy.url = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            estateObject: args[0],
            loan: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        estateObject: typeof args.estateObject === 'object'
        ? args.estateObject.id
        : args.estateObject,
        loan: typeof args.loan === 'object'
        ? args.loan.id
        : args.loan,
    }

    return destroy.definition.url
            .replace('{estateObject}', parsedArgs.estateObject.toString())
            .replace('{loan}', parsedArgs.loan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LoanController::destroy
* @see app/Http/Controllers/LoanController.php:45
* @route '//app.finesthub.de/properties/{estateObject}/loans/{loan}'
*/
destroy.delete = (args: { estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } } | [estateObject: string | number | { id: string | number }, loan: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const LoanController = { store, update, destroy }

export default LoanController